import { collection, getDocs, query, where, onSnapshot } from 'firebase/firestore'
import { defineStore } from 'pinia'
import { useProjectStore } from '@/store/projectStore'
import { useVendorStore } from '@/store/vendorStore'
import { db } from '@/plugins/firebase'
import getVendorPaymentData from '@/shared/payments/getVendorPaymentData'

export const useProductStore = defineStore('productStore', {
  state: () => ({
    products: [],
  }),
  getters: {
    areProductsExtra() {
      const vendorStore = useVendorStore()
      return !!getVendorPaymentData(vendorStore.vendor)?.accountId && this.products.length > 0
    },
  },
  actions: {
    async bindProducts({ organizationId, projectId }) {
      const compProjectIdsForEnrollment = `organization-${organizationId}--project-${projectId}`
      const q = query(
        collection(db, 'products'),
        where('organizationId', '==', organizationId),
        where('compProjectIdsForEnrollment', 'array-contains', compProjectIdsForEnrollment),
        where('isActive', '==', true),
        where('isPublished', '==', true),
      )

      onSnapshot(q, snapshot => {
        const productDocs = [...snapshot.docs.map(doc => doc.data())].sort((a, b) => a.index - b.index)
        const groupedProducts = Object.values(
          productDocs.reduce((acc, item) => {
            const {
              archetypeId,
              id,
              description,
              images,
              name,
              price,
              oldPrice,
              shippingRateIds,
              suffix,
              featured,
              vendorProductId,
              stock,
            } = item
            if (!acc[archetypeId]) {
              acc[archetypeId] = {
                id,
                description,
                archetypeId,
                images,
                name,
                price,
                oldPrice,
                shippingRateIds,
                featured,
                sizes: [],
                product: null,
                ...(suffix ? { sizes: [] } : { vendorProductId }),
                stock
              }
            }
            if (suffix) { acc[archetypeId].sizes.push({ value: id, title: suffix, vendorProductId, price, oldPrice, stock }) }
            return acc
          }, {}),
        )
        this.products = groupedProducts
      })
    }
  },
})
